/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Injector, Input } from '@angular/core';
import { type Command, type PromptConfigFull, FormControl, FormGroup, FormSlideWindowAbstract, UNPLACEHOLDER } from '@dm/core';
import { HomedirRule } from 'app/common/types/mo';

import { CifsShareStrService } from '../../cifs-share-str.service';
import { HomedirRuleCifsShareService } from './../homedir-rule-cifs-share.service';

@Component({
    selector: 'app-modify-homedir-rule-cifs-share',
    templateUrl: './modify-homedir-rule-cifs-share.component.html',
    styleUrls: ['./modify-homedir-rule-cifs-share.component.scss'],
})
export class ModifyHomedirRuleCifsShareComponent extends FormSlideWindowAbstract implements OnInit {
    @Input() data: HomedirRule;
    @Input() vstoreId: string;
    @Input() vstoreName: string;
    /**
     * 前台表格传入true
     */
    @Input() isFrontTable = false;

    i18n = this.str.i18n;
    closeArgs = { refresh: false, data: null };
    UNPLACEHOLDER = UNPLACEHOLDER;

    vm: FormGroup;
    errorMessage: any;

    get vmValue(): HomedirRule {
        return this.vm ? this.vm.value : null;
    }

    constructor(
        injector: Injector,
        public str: CifsShareStrService,
        private service: HomedirRuleCifsShareService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.pageReady = true;
        this.windowVisible = true;
    }

    initVm(): void {
        this.vm = new FormGroup({
            priority: new FormControl(this.data.priority, [
            ]),
            autoCreate: new FormControl(typeof this.data.autoCreate === 'string' ?
                this.data.autoCreate === 'true' :
                this.data.autoCreate),
        }, { updateOn: 'blur' });

        this.errorMessage = {
        };
    }

    prompt(): PromptConfigFull[] {
        // 只有修改优先级有高危提示, 且前台表格不弹
        if (Number(this.data.priority) === Number(this.vmValue.priority) || this.isFrontTable) {
            return [];
        }
        const prompts: PromptConfigFull[] = [
            {
                id: 'prompt-modify-homedir-rule-cifs-share-setHomedirRule',
                opType: 'warning',
                title: this.i18n.title.modifyMappingRule,
                content: this.i18n.highRisk.setHomedirRule,
                width: 700,
            },
        ];

        return prompts;
    }

    collectionRuleParam(): HomedirRule {
        const vmValue = this.vmValue;
        return {
            priority: vmValue.priority,
            autoCreate: vmValue.autoCreate,
        };
    }

    buildCmds(): Command[] {
        const params = this.collectionRuleParam();
        if (this.isFrontTable) {
            this.closeArgs.data = params;
            return [];
        } else {
            const cmds: Command[] = [this.buildCIFSCmd(params)];
            return cmds;
        }
    }

    /**
     * 构建修改共享的rest
     */
    buildCIFSCmd(params: HomedirRule): Command {
        if (this.data.vstoreId) {
            params.vstoreId = this.data.vstoreId;
        }
        return {
            name: this.i18n.rest.homedir.modifyRule,
            nameParams: [this.data.NAME, this.data.fsPath],
            action: this.service.modify(this.data.ID, params),
        };
    }
}
